export const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

export type TailwindBreakpoint = keyof typeof TAILWIND_BREAKPOINTS;

/**
 * Tailwind breakpoints are defined as min-width media queries.
 * For max-width comparisons (e.g., "screen <= lg") subtract 1px.
 */
export const getMaxWidthForBreakpoint = (
  breakpoint: TailwindBreakpoint,
): number => {
  return TAILWIND_BREAKPOINTS[breakpoint] - 1;
};
